export type PieChartDataFormat = {
    value: number;
    type: string;
};

export type BarChartDataFormat = {
    label: string;
    solar: number;
    wind: number;
    battery: number;
    thermal: number;
    other: number;
};

export type PieChartConfigType = {
    data: PieChartDataFormat[];
    title: string;
    summary?: number;
};

export type BarChartConfigType = {
    data: BarChartDataFormat[];
    title: string;
    textOverride?: string;
};

export const COLORS = {
    teal: "#32ADB1",
    blue: "#4361B1",
    green: "#7ACC7D",
    pink: "#FF94B0",
    yellow: "#FFE682",
    orange: "#FF8C42",
};

export type GenerationTypes = {
    [key: string]: {
        label: string;
        color?: string;
    };
};

export const CHART_TYPE_MAP: GenerationTypes = {
    solar: {
        label: "Solar",
        color: COLORS["blue"],
    },
    wind: {
        label: "Wind",
        color: COLORS["yellow"],
    },
    battery: {
        label: "Battery/Storage",
        color: COLORS["green"],
    },
    thermal: {
        label: "Thermal",
        color: COLORS["pink"],
    },
    other: {
        label: "Other",
        color: COLORS["orange"],
    },
} as const;
